<template>
	<v-container fluid pt-o>
		<v-row class="pa-2">
			<v-btn @click="saveClick" color="success" depressed>
				{{ $t('buttons.save') }}
				<v-icon right>fa-save</v-icon>
			</v-btn>
		</v-row>
		<v-row>
			<v-col lg="8" cols="12">
				<v-card outlined flat>
					<v-card-text>
						<v-row>
							<v-col md="6" cols="12">
								<InputField
									:error="userValidation.username"
									:label="$t('fields.username')"
									v-model="user.username"></InputField>
							</v-col>
							<v-col md="12" cols="12">
								<CheckBox
									:label="$t('fields.passwordChange')"
									v-model="user.password_change"></CheckBox>
							</v-col>
							<template v-if="user.password_change">
								<v-col md="12" cols="12">
									<InputField
										:error="userValidation.old_password"
										:label="$t('fields.oldPassword')"
										:type="'password'"
										v-model="user.old_password"></InputField>
								</v-col>
								<v-col md="6" cols="12">
									<InputField
										:error="userValidation.new_password"
										:label="$t('fields.newPassword')"
										:type="'password'"
										v-model="user.new_password"></InputField>
								</v-col>

								<v-col md="6" cols="12">
									<InputField
										:error="userValidation.new_password_confirmation"
										:label="$t('fields.newPasswordConfirmation')"
										:type="'password'"
										v-model="user.new_password_confirmation"></InputField>
								</v-col>
							</template>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField"
import CheckBox from "./trinkets/CheckBox";

export default {
	name: "Profile",
	components: {CheckBox, InputField},
	data: function () {
		return {
			user: {
				username: '',
				oib: '',
				password_change: false,
				old_password: '',
				new_password: '',
				new_password_confirmation: ''
			},
			userValidation: {
				username: '',
				oib: '',
				old_password: '',
				new_password: '',
				new_password_confirmation: ''
			}
		}
	},
	methods: {
		backClick() {
			this.$router.push('/dashboard');
		},
		saveClick() {

			let success = true;

			if (this.user.username == '') {
				success = false;
				this.userValidation.username = this.$t('alerts.usernameMissing');
			} else {
				this.userValidation.username = '';
			}

			if (this.user.password_change) {
				if (this.user.old_password == '') {
					success = false;
					this.userValidation.old_password = this.$t('alerts.passwordMissing');
				} else {
					this.userValidation.old_password = '';
				}

				if (this.user.new_password == '') {
					success = false;
					this.userValidation.new_password = this.$t('alerts.passwordMissing');
				} else {
					if (this.user.new_password.length < 8) {
						success = false;
						this.userValidation.new_password = this.$t('alerts.passwordLength');
					} else {
						this.userValidation.new_password = '';
					}
				}

				if (this.user.new_password != this.user.new_password_confirmation) {
					success = false;
					this.userValidation.new_password_confirmation = this.$t('alerts.passwordFailConfirmation');
				} else {
					if (this.user.new_password_confirmation.length < 8) {
						success = false;
						this.userValidation.new_password_confirmation = this.$t('alerts.passwordLength');
					} else {
						this.userValidation.new_password_confirmation = '';
					}
				}
			} else {
				this.userValidation.old_password = '';
				this.userValidation.new_password = '';
				this.userValidation.new_password_confirmation = '';
			}

			if (success) {
				let vm = this;
				this.$APICall('put', 'users/' + this.$myStore.state.user.id, this.user, (data, success) => {
					if (success) {
						vm.$notify(vm.$t('alerts.basicUpdate'));
					} else {
						if (vm.user.password_change) {
							vm.$alert(vm.$t('alerts.oldPasswordFail'));
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					}
				});
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.profile'), href: '/profile', disabled: true}
		]);
		let vm = this;
		this.$APICall('get', 'users/' + this.$myStore.state.user.id, {}, (data, success) => {
			if (success) {
				let userData = data;
				userData.password_change = false;
				userData.old_password = '';
				userData.new_password = '';
				userData.new_password_confirmation = '';
				vm.user = userData;
			}
		});
	}
}
</script>

<style scoped>

</style>
